import { render } from "./ProductoModal.vue?vue&type=template&id=d4e920fa"
import script from "./ProductoModal.vue?vue&type=script&lang=js"
export * from "./ProductoModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__